import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "serp__filter-filter--container q-py-1 q-shadow-sm q-my-2 q-mb-2 q-rounded-3 q-bg-white"
}
const _hoisted_2 = { class: "q-accordion-item" }
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "q-accordion-body q-p-1" }
const _hoisted_5 = { class: "serp__filter-item--container" }

import {inject, onMounted, onUnmounted, watch, ref} from "vue";
import ClearFiltersButtonContainer
  from '@/components/SerpPage/FiltersContainer/ClearFiltersButton/ClearFiltersButtonContainer.vue'
import MarkedFiltersContainer from '@/components/SerpPage/FiltersContainer/MarkedFilters/MarkedFiltersContainer.vue'

import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {SmartSearchConfigInterface} from "@/core/types";

import {storeToRefs} from "pinia";
import {useMobileViewStore} from "@/store/MobileViewStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'UsedFilterContainer',
  props: ['filter', 'filterCollapsed'],
  setup(__props) {

const props = __props
const isCollapsed = ref(props.filterCollapsed || false);

function toggleAccordion() {
  isCollapsed.value = !isCollapsed.value;
}


// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!
const filtersStore = useFiltersStore();
const mobileViewStore = useMobileViewStore();
const {canShowFiltersOnMobile} = storeToRefs(filtersStore)
const {isMobileView} = storeToRefs(mobileViewStore)
const useMarkedFilters = SmartSearchConfig.value.serp.markedFilters.enabled

const {hasSelectedFilters} = storeToRefs(filtersStore)

watch(canShowFiltersOnMobile, (newValue) => {
  filtersStore.setBodyScroll(!newValue);
});

onMounted(() => {
  filtersStore.fetchFilters();
  window.addEventListener('popstate', () => {
    filtersStore.fetchFilters();
  });
});

onUnmounted(() => {
  window.removeEventListener('popstate', () => {
    filtersStore.fetchFilters();
  });
});


return (_ctx: any,_cache: any) => {
  return ((_unref(isMobileView) && _unref(useMarkedFilters) && _unref(hasSelectedFilters)) || (!_unref(isMobileView) && _unref(hasSelectedFilters)))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h6", {
            class: _normalizeClass(["q-accordion-header q-position-relative serp__filter-item--header q-accordion-button q-rotatable q-p-3 q-py-2 q-mt-0 q-fs-6 q-my-0 q-fw-semibold", {'q-collapsed': isCollapsed.value, 'q-rotated': !isCollapsed.value}]),
            onClick: toggleAccordion,
            "aria-expanded": !isCollapsed.value.toString()
          }, _toDisplayString('Użyte filtry'), 10, _hoisted_3),
          _createElementVNode("div", {
            class: _normalizeClass(["q-accordion-collapse", {'q-collapse': isCollapsed.value, 'q-show': !isCollapsed.value}])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (!_unref(isMobileView))
                  ? (_openBlock(), _createBlock(ClearFiltersButtonContainer, { key: 0 }))
                  : _createCommentVNode("", true),
                (_unref(useMarkedFilters) && _unref(hasSelectedFilters))
                  ? (_openBlock(), _createBlock(MarkedFiltersContainer, { key: 1 }))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})